<script setup>
import Toggle from "@vueform/toggle/src/Toggle.vue";

defineProps({
  modelValue: {
    required: true,
    type: Boolean,
  },
});

const emit = defineEmits(['update:modelValue']);

</script>
<template>
  <Toggle
    v-model="
      // eslint-disable-next-line vue/no-mutating-props
      modelValue
    "
    :classes="{
      container: 'tw-inline-block tw-rounded-full tw-outline-none',
      toggle: 'tw-flex tw-w-[51px] tw-h-[26px] tw-rounded-full tw-relative tw-cursor-pointer tw-transition tw-items-center tw-box-content tw-border-2 tw-text-xs tw-leading-none',
      toggleOn: 'tw-bg-blue tw-border-blue tw-text-grey-mid',
      toggleOff: 'tw-bg-grey-mid tw-border-grey-mid tw-text-grey',
      handle: 'tw-inline-block tw-bg-white tw-w-[24px] tw-h-[24px] tw-rounded-full tw-absolute tw-transition-all',
      handleOn: 'tw-left-full tw-transform -tw-translate-x-full',
      handleOff: 'tw-left-0',
    }"
    @change="emit('update:modelValue', modelValue)"
  />
</template>

